export default __webpack_public_path__ + "static/touch-icon-9a8f6db4b02ca1c88ad33f01061be746.png";